import axios from 'axios';
import router from '../router';
import qs from 'qs'
import Vue from "vue"
import { Message } from 'element-ui'

axios.defaults.headers["Content-Type"] = "application/json";
axios.defaults.headers["Accept-Language"] = "en";
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL, // api 的 base_url
  // baseURL: 'http://10.4.248.129:9200', // api 的 base_url
  // baseURL: 'http://10.4.216.51:9200', // api 的 base_url
  timeout: 60000
})

service.interceptors.request.use(
  (config) => {
    // var configData = config.data;
    const flag =
      config.headers["Content-Type"] &&
      config.headers["Content-Type"].indexOf("application/json") !== -1;
    if (!flag) {
      const mult =
        config.headers["Content-Type"] &&
        config.headers["Content-Type"].indexOf("multipart/form-data") !== -1;
      if (!mult) {
        config.data = qs.stringify(config.data);
      }
    }
    //如果存在token，请求携带这个token
    if (Vue.ls.get("token")) {
      config.headers["Authorization"] =
        "Bearer " + Vue.ls.get("token");
    }
    return config;
  },
  (error) => {
    Promise.reject(error)
  }
);

//响应拦截
service.interceptors.response.use(
  (response) => {
    if (response.config.url == '/api-sp/sp/device/downloadLicense') {
      const res = response
      return res
    } else {
      const res = response.data
      return res
    }
  },

  (error) => {
    const err = error.response
    if (err.status == 401 || err.status == 403) {
      Vue.ls.clear(),
        delete service.defaults.headers['Authorization']
      if (router.currentRoute.path !== '/login') {
        router.replace({ path: 'login' })
      }

      let message = ''
      if (error.response.status === 401) {
        message = 'Login status expired, please log in again'
      } else {
        message = error.response.data.message || error.response.data.msg
      }
      Message({
        message: message,
        type: "error",
        duration: 4 * 1000,
      })

    } else if (err.status == 500) {
      if (err.config.url == "/api-sp/sp/device/downloadLicense") {
        let data = err.data
        let fileReader = new FileReader()
        fileReader.readAsText(data)
        fileReader.onload = function (result) {
          let jsondata = JSON.parse(result.target.result)
          Message({
            message: jsondata.msg,
            type: "error",
            duration: 4 * 1000,
          })
        }
      } else {
        Message({
          message: err.data.msg,
          type: "error",
          duration: 4 * 1000,
        })
      }
    }
    return Promise.reject(error);
  }
)

export default service